module.exports = __webpack_public_path__ + "cc28648c5dd10ecc161691e4b040a892.png";